import {
  FC,
  JSX,
  useState
} from "react";
import { Text, View } from "react-native";
import CheckMainBlock from "@/app/components/CheckMainBlock";
import InputWithBlur from "@/app/components/InputWithBlur";
import CheckBalance from "@/app/components/CheckBalance";
import CustomButton from "@/app/components/CustomButton";
import { isInnValid } from "@/_utils/validation";
import useErrorHandler from "@/_hooks/Toasters/useHandlerError";
import bgBell from "@/assets/icons/main/bg.png";

interface ISearchBannerProps {
  onSearch: (inn: string) => Promise<void>;
}

const BlockSearchBanner: FC<ISearchBannerProps> = ({
  onSearch
}): JSX.Element => {
  const [inn, setInn] = useState<string>("");
  const { handleError } = useErrorHandler();

  const handleSearch = async (): Promise<void> => {
    try {
      await onSearch(inn);
      setInn("");
    } catch (error: any) {
      handleError(error, "При отправке запроса произошла ошибка. Пожалуйста, попробуйте снова позже.");
    }
  };

  const isDisabled = !inn.trim() || !isInnValid(inn);

  return (
    <CheckMainBlock bgColor="#146DE6" bgImage={bgBell}>
      <Text className="text-white text-2xl font-bold mb-3">
        Проверить<br/>
        компанию или ИП
      </Text>
      <Text className="text-white text-base font-normal opacity-80 mb-5">
        Узнайте рейтинг компании по различным показателям.
      </Text>
      <InputWithBlur
        placeholder="Введите ИНН"
        placeholderTextColor="rgba(255, 255, 255, 0.80)"
        value={inn}
        onChangeText={setInn}
        maxLength={12}
        keyboardType="numeric"
      />
      <CustomButton
        className="mb-4"
        title="Проверить сейчас"
        type="primary"
        style={{
          backgroundColor: "#fff",
          opacity: isDisabled ? 0.5 : 1
      }}
        textStyle={{ color: "#1677FF"  }}
        onPress={handleSearch}
        disabled={isDisabled}
      />
      <View className="flex-row items-center justify-center space-x-2">
        <Text className="text-white text-sm font-normal">
          Осталось:
        </Text>
        <CheckBalance>
          Безлимит
        </CheckBalance>
      </View>
    </CheckMainBlock>
  );
};

export default BlockSearchBanner;
